export default __webpack_public_path__ + "static/media/comunidade.8492cf58.svg";